import React from 'react';
import { SVGProps } from './types';

function CancelIcon(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M15.833 4.167L4.167 15.833m0-11.666l11.666 11.666"
      />
    </svg>
  );
}

export { CancelIcon };
